module.exports = __webpack_public_path__ + "img/imgBaby02.1fe60663.jpg";